import { default as gql } from 'nanographql'

const API_PROTOCOL = process.env.VUE_APP_API_PROTOCOL || 'https'
const API_HOST = process.env.VUE_APP_API_HOST || 'traficar.karashome.pl'
const API_PATH = process.env.VUE_APP_API_PATH || ''

const baseUrl = () => API_PROTOCOL + '://' + API_HOST + API_PATH;

const headers = (contentType = 'application/json') => {
  let headers = {
    'Accept': 'application/json',
  }
  if (contentType) {
    headers['Content-Type'] = contentType;
  }
  return headers;
}

const jsonResponseHandler = (response, resolve, reject) => {
  if (!response.ok) {
    reject(response);
  } else {
    response.json()
        .then((data) => {
          if (data.errors) {
            // handle graphql errors
            reject({
              json: async () => {
                return {
                  message: data.errors[0].message
                }
              }
            })
          } else {
            resolve(data.data ? data.data : data)
          }
        })
        .catch((e) => reject(e))
    ;
  }
}

const graphql = async (query, variables = {}) => {
  return new Promise((resolve, reject) => {
    fetch(baseUrl() + '/graphql', {
      method: 'POST',
      headers: headers(),
      body: (gql(query))(variables),
    }).then((response) => {
      jsonResponseHandler(response, resolve, reject);
    }).catch((e) => reject(e));
  })
}

const api = {
  async getCars(){
    return graphql(`
      query Cars {
        cars {
          available,
          cityId,
          modelId,
          number,
          regNumber,
          vin,
          location,
          coordinate {
            latitude,
            longitude
          },
          range,
          fuel,
          discount
        },
        models {
          id,
          externalId,
          name,
          isTransporter,
          isElectric,
          fuelCapacity,
          frontImageUrl
        },
        cities {
          id,
          externalId,
          name,
          coordinate {
            latitude,
            longitude
          }
        }
      }`
    )
  }
}

export default api